module.exports = __webpack_public_path__ + "assets/b8958bcf8397de6aa5fbfed3cbbba7e1.jpg";